import { ref } from 'vue'

import { defineStore } from 'pinia'

import { useNotificationStore } from '@/stores/helpers/notification.js'
import DashboardService from '@/services/retailer/DashboardService.js'


import { errorMessage } from '@/utilities/helpers.js'

import { DASHBOARD_ERROR_MESSAGES } from '@/constants/errorMessages.js'

export const useDashboardStore = defineStore('retailerDashboard', () => {
  const notificationStore = useNotificationStore()

  const dashboard = ref([])
  const retailer_standing_type = ref(0)
  const menuItemsBadgeCount = ref({})
  const lastOrders = ref([])
  const activeSeasonInfo = ref({})
  const lastSeasonInfo = ref({})
  const ranking = ref({})

  const getDashboard = params => {
    return new Promise((resolve, reject) => {
      DashboardService.getDashboard(params)
        .then(response => {
          dashboard.value = response.data
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: DASHBOARD_ERROR_MESSAGES.getDashboardError + errorMessage(err)
          }
          notificationStore.add(notification)
          reject(err)
        })
    })
  }

  const getDashboardMenuItemsBadgeCount = () => {
    return new Promise((resolve, reject) => {
      DashboardService.getDashboardMenuItemsBadgeCount()
        .then(response => {
          menuItemsBadgeCount.value = response.data
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: DASHBOARD_ERROR_MESSAGES.getDashboardMenuItemsBadgeCountError + errorMessage(err)
          }
          notificationStore.add(notification)
          reject(err)
        })
    })
  }

  const getLastOrders = () => {
    return new Promise((resolve, reject) => {
      DashboardService.getLastOrders()
        .then(response => {
          lastOrders.value = response.data
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: DASHBOARD_ERROR_MESSAGES.getLastOrdersError + errorMessage(err)
          }
          notificationStore.add(notification)
          reject(err)
        })
    })
  }

  const getSeasonInfo = () => {
    return new Promise((resolve, reject) => {
      DashboardService.getSeasonInfo()
        .then(response => {
          activeSeasonInfo.value = response.data.active_season
          lastSeasonInfo.value = response.data.last_season
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: DASHBOARD_ERROR_MESSAGES.getSeasonInfoError + errorMessage(err)
          }
          notificationStore.add(notification)
          reject(err)
        })
    })
  }

  const getRanking = params => {
    return new Promise((resolve, reject) => {
      DashboardService.getRanking(params)
        .then(response => {
          ranking.value = response.data
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: DASHBOARD_ERROR_MESSAGES.getRankingError + errorMessage(err)
          }
          notificationStore.add(notification)
          reject(err)
        })
    })
  }

  const setValue = parameters => {
    if (parameters.type === 'retailer_standing_type') {
      retailer_standing_type.value = parameters.value
    } else if (parameters.type === 'menuItemsBadgeCount') {
      menuItemsBadgeCount.value = parameters.value
    } else if (parameters.type === 'lastOrders') {
      lastOrders.value = parameters.value
    } else if (parameters.type === 'activeSeasonInfo') {
      activeSeasonInfo.value = parameters.value
    } else if (parameters.type === 'lastSeasonInfo') {
      lastSeasonInfo.value = parameters.value
    } else if (parameters.type === 'ranking') {
      ranking.value = parameters.value
    }
  }

  return {
    dashboard,
    retailer_standing_type,
    menuItemsBadgeCount,
    lastOrders,
    activeSeasonInfo,
    lastSeasonInfo,
    ranking,
    getDashboard,
    getDashboardMenuItemsBadgeCount,
    getLastOrders,
    getSeasonInfo,
    getRanking,
    setValue
  }
})
